





























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue, { PropType } from 'vue'

export default Vue.extend({
  props: {
    name: {
      type: String as PropType<string>,
      required: true,
    },
    width: {
      type: String as () => string,
      default: '',
    },
  },
  data() {
    return {
      uid: null,
    }
  },
  mounted() {
    // @ts-ignore
    this.uid = this._uid
  },
})
